import V from 'voUtils/V.js';

import {
	isBlank,
	objectIsSimilar
}
from 'voUtils/tools.js';

import {
	fireSearch
}
from 'voUtils/TagEx.js';

import {
	doReq
}
from 'voUtils/RestEx.js';

import {
	getVoucher
}
from 'voUtils/VoucherStore.js';
import {
	getAbTest
}
from 'voUtils/AbTest.js';

import {
	getFavIds
}
from 'voUtils/FavStore.js';

import {
	findResultFields
}
from 'voUtils/BrowserEx.js';


export default {
	data: {
		mapItems: [{
			"_id": 1,
			"sectionid": "carlsart78",
			"name": "Carls Art 78 - Bildung",
			"loc": {
				"coordinates": [9.807322341104422, 54.485939595750324]
			}
		}, {
			"_id": 2,
			"sectionid": "keramikahoi",
			"name": "Keramik Ahoi - Bildung",
			"loc": {
				"coordinates": [9.83435664723895, 54.47279664993722]
			}
		}, {
			"_id": 3,
			"sectionid": "kunstwerkcarlshutte",
			"name": "Kunstwerk Carlshütte - Bildung",
			"loc": {
				"coordinates": [9.668478670552211, 54.31221901916467]
			}
		}, {
			"_id": 4,
			"sectionid": "kunsthauskapelnev",
			"name": "Kunsthaus Kappeln e.V. - Bildung",
			"loc": {
				"coordinates": [9.93337067055221, 54.66095795106]
			}
		}, {
			"_id": 5,
			"sectionid": "shcleiarts",
			"name": "Schlei-arts - Bildung",
			"loc": {
				"coordinates": [9.99225469386547, 54.68409427234562]
			}
		}, {
			"_id": 6,
			"sectionid": "schleimuseumkappeln",
			"name": "Schleimuseum Kappeln - Bildung",
			"loc": {
				"coordinates": [9.928250670552213, 54.661689502315426]
			}
		}, {
			"_id": 7,
			"sectionid": "stnicolaistrabeineckerforde",
			"name": "St. Nicolaistraße in Eckerförde - Bildung",
			"loc": {
				"coordinates": [9.83544932944779, 54.47207732592944]
			}
		}, {
			"_id": 8,
			"sectionid": "topfereistock",
			"name": "Töpferei Stock - Bildung",
			"loc": {
				"coordinates": [9.922521023313257, 54.663843889640546]
			}
		}, {
			"_id": 9,
			"sectionid": "wikingermuseumhaithabuinbusdorf",
			"name": "Wikinger-Museum Haithabu in Busdorf - Bildung",
			"loc": {
				"coordinates": [9.56926034110442, 54.49701776195279]
			}
		}],
	},
	beforeMount: function () {

	},
	updated: function () {

	},
	computed: {

	},
	watch: {

	}

};